import { InputEvents, Metrics, Obj, ObjectState, Surface, } from "../types";
import { createParagraphObject, CreateParagraphObjectArgs } from "./paragraph"

type CreateParagraphFpsArgs = Omit<CreateParagraphObjectArgs, "text">;

export const createParagraphFps = (args: CreateParagraphFpsArgs) => {
  const pObj = createParagraphObject({ ...args, text: "FPS 0" });
  const step = (startTime: number, timestamp: number, inputEvents: InputEvents, metrics: Metrics, inFocus: boolean, objectState: ObjectState, surface: Surface, obj: Obj) => {
    const text = `FPS ${metrics.fps.toFixed(0)}`;
    pObj.setText(text);
    pObj.step(startTime, timestamp, inputEvents, metrics, inFocus, objectState, surface, obj);
  }
  return {
    ...pObj,
    step,
  };
}
